<template>
   <div>
      <div class="row p-2 mt-4">
         <div class="col-12">
            <span class="custom-span-lg" style="color: #435666;">Admin Settings
               <i class="fa-solid fa-arrow-right"></i>
            </span>
            <span class="custom-span-no-weight" style="color: #435666;"> &nbsp;Cron Jobs</span>
            <div class="mt-2">
               <small class="text-muted">
                  <i class="fa-solid fa-clock-rotate-left me-1" style="color: #00A0C1;"></i>
                  Manage scheduled background tasks. Toggle auto-run or trigger jobs manually.
               </small>
            </div>
         </div>
      </div>

      <CronJobs />
   </div>
</template>

<script>
import CronJobs from '@/components/Admin Controls/CronJobs.vue';

export default {
   components: { CronJobs },
}
</script>

<style scoped>
.custom-span-lg { font-size: 24px; line-height: 24px; font-weight: bold; }
.custom-span-no-weight { font-size: 24px; line-height: 24px; font-weight: 250; }
</style>
